let view_loads;
const mixin_view = {
	$_showLoading : function  (text = '加载中'){
		view_loads = this.$loading({
			lock : true,
			text : text,
			background : 'rgba(255,255,255,0.5)',
		})
		// this.$vue_vuex('loads',loading);
	},
	$_hideLoading : function  (){
		view_loads.close();
	},
	$_showToast : function  (message='',type='success'){
		type = type == 'cancel' ? 'error' : type;
		this.$message({
			message : message,
			type : type
		})
	},
	$_showToastNone : function (message){
		this.$message({
			message : message,
			type : 'error'
		})
	},
	$_showToastInfo : function (message){
		this.$message({
			message : message,
			type : 'info'
		})
	},
	$_showToastWarning : function (message){
		this.$message({
			message : message,
			type : 'warning'
		})
	},
	$_alert : async function  (content='',title='提示'){
		try{
			let res = await this.$alert(content, title,{
				confirmButtonText : '确定'
			})
			if (res == 'confirm'){
				return true;
			}else{
				return false;
			}
		}catch (e){
			console.log(e);
			return false;
		}
	},
	$_confirm : async function  (content='',title='提示',type='info'){
		try{
			let res = await this.$confirm(content,title,{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: type
			});
			if (res == 'confirm'){
				return true;
			}else{
				return false;
			}
		}catch (e){
			console.log(e);
			return false;
		}
	},
	$_prompt : async function  (content='',title='输入',rule='',placeholder='请输入'){
		try{
			let res = await this.$prompt(content, title,{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern:rule,
				inputErrorMessage: placeholder
			});
			if (res.action == 'confirm'){
				return res.value;
			}else{
				return '';
			}
		}catch (e){
			console.log(e);
			return '';
		}
	},
	$_showNotice : function  (message='',title='提示'){
		this.$notify({
			title : title,
			message : message,
			type : 'success'
		})
	},
	$_showNoticeError : function  (message='',title='提示'){
		this.$notify({
			title : title,
			message : message,
			type : 'error'
		})
	},
	$_showNoticeInfo : function  (message='',title='提示'){
		this.$notify({
			title : title,
			message : message,
			type : 'info'
		})
	},
	$_showNoticeWarning : function  (message='',title='提示'){
		this.$notify({
			title : title,
			message : message,
			type : 'warning'
		})
	},
	vue_auto_upload : async function  (e){
		try{
			let data = e.data || false;
			if (!data){
				console.log('请绑定data数据');
				return ;
			}
			let file = e.file || false;
			if (file){
				this.$_showLoading('上传中');
				let res = await this.$_api.upload(file);
				this.$_hideLoading();
				if (res.errcode != 0){
					this.$_showToastWarning(res.errmsg);
					return ;
				}
				if (data.list){
					let list = this[data.data][data.name];
					list.push(res.url);
					this[data.data][data.name] = list;
				}else{
					if (data.name){
						this[data.data][data.name] = res.url;
					}else{
						this[data.data] = res.url;
					}
				}
			}
		}catch (e){
			console.log(e);
			return false;
		}
	},
	vue_form_upload : function  (e){
		console.log(e);
		let data = e.data || false;
		if (!data){
			console.log('请绑定data数据');
			return ;
		}
		if (!e.url){
			console.log('上传返回出错');
			return;
		}
		if (data.list){
			if (data.is_server){
				let list = this[data.data][data.name];
				list = list.concat(e.url);
				this[data.data][data.name] = list;
			}else{
				let list = this[data.data][data.name];
				list.push(e.url);
				this[data.data][data.name] = list;
			}
		}else{
			if (data.name){
				this[data.data][data.name] = e.url;
			}else{
				this[data.data] = e.url;
			}
		}
	},
	vue_form_upload_del : function  (e){
		let data = e.data || false;
		if (!data){
			console.log('请绑定data数据');
			return ;
		}
		if (data.name){
			this[data.data][data.name] = e.list;
		}else{
			this[data.data] = e.list;
		}
	},
	vue_upload_del : function  (index,list,main_name,sub_name=''){
		let data = this.$tools.unset(list,index);
		if (sub_name){
			this[main_name][sub_name] = data;
		}else{
			this[main_name] = data;
		}
	},
	vue_pop_show_hide : function  (show){
		if (show.callback){
			show.callback(show);
		}else{
			if (show.constructor === Boolean){
				this.is_pop = show;
			}else{
				this[show.keyword] = show.show;
			}
		}

	},
	//f-upload
	vue_f_upload : function  (e){
		console.log(e);
		let data = e.data || false;
		if (!data){
			console.log('data-data 必填设置')
			return;
		}
		if (data.is_list){
			if (data.is_server){
				if (data.name){
					if (this[data.data][data.name]){
						let list = this[data.data][data.name];
						list = list.concat(e.url);
						this[data.data][data.name] = list;
					}else{
						let list = [];
						list.push(e.url);
						this.$set(this[data.data],data.name,list);
					}
				}else{
					let list = this[data.data];
					list = list.concat(e.url);
					this[data.data] = list;
				}
			}else{
				if (data.name){
					if (this[data.data][data.name]){
						let list = this[data.data][data.name];
						list.push(e.url);
						this[data.data][data.name] = list;
					}else{
						let list = [];
						list.push(e.url);
						this.$set(this[data.data],data.name,list);
					}
				}else{
					let list = this[data.data];
					list.push(e.url);
					this[data.data] = list;
				}
			}
		}else{
			if (data.name){
				if (this[data.data][data.name]){
					this[data.data][data.name] = e.url;
				}else{
					this.$set(this[data.data],data.name,e.url);
				}
			}else{
				this[data.data] = e.url;
			}
		}
	},
	vue_f_del : function  (e){
		if (e.name){
			let list = this[e.data][e.name];
			list = this.$tools.unset(list,e.key);
			this[e.data][e.name] = list;
		}else{
			let list = this[e.data];
			list = this.$tools.unset(list,e.key);
			this[e.data] = list;
		}
	},
};

export default mixin_view;
